import { useState, useEffect } from 'react';
import KeycloakService from '../Services/KeycloakService';
import { useLocation } from 'react-router';
import MainLoader from '../components/MainLoader';
import { AUTH_ROUTES } from './AuthRoute';
import { apiGetProfil } from '../Api/Profile/Profile';
import { useDispatch } from 'react-redux';
import { serilizeGetMembers } from '../Api/Profile/serilizeProfile';
const Protected = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!KeycloakService.isLoggedIn()) {
      const routeNames = AUTH_ROUTES.map((r) => r.route.toLowerCase());
      const routesWithRedirect = [...routeNames, '/redirect/to'];

      if (
        !routesWithRedirect.includes(pathname.toLowerCase()) &&
        !pathname.toLowerCase().includes('firstlogin')
      ) {
        KeycloakService.doLogin();
      } else {
        setLoading(false);
      }
    } else {
      fetchProfil(KeycloakService.getToken());
    }
  }, [pathname]);

  const getProfile = async (token) => {
    const res = await apiGetProfil(token);
    if (res.status == 200) {
      const action = {
        type: 'SET_PROFILE',
        value: {
          profile: serilizeGetMembers(res, res.memberType)
        }
      };
      dispatch(action);

      const action2 = {
        type: 'SET_CURRENT_USER',
        value: {
          accessToken: token,
          refreshToken: null,
          user: {
            ...res,
            email: res?.mailPhoneFax?.emailAddress,
            token,
            contractTypes: res.contracts?.map((contract) => contract.family),
            memberNumber: res.number,
            memberId: res.id,
            memberType: res.memberType
          }
        }
      };
      dispatch(action2);
      if (res.memberType === 'Affiliate') {
        localStorage.setItem('showCgrmModal', 'true');
      }
      setLoading(false);
    }
  };

  const fetchProfil = async (token) => {
    if (token) {
      await getProfile(token);
    }
  };

  if (loading)
    return (
      <div
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          zIndex: 9999,
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          backgroundColor: '#ffffff80'
        }}
      >
        <MainLoader />
      </div>
    );

  return KeycloakService.isLoggedIn() ? children : null;
};

export default Protected;
